import PropTypes from "prop-types";
import DefaultImage from "./DefaultImage";
import clsx from "clsx";
import { productImageSrc } from "vino/utils";

const Image = (props) => {
	const { className, image } = props;
	return (
		<div className={clsx("flex w-full justify-center", className)}>
			{image?.imageSrc ? (
				<div className="flex w-full justify-center">
					<img
						src={productImageSrc(image)}
						alt=""
						className={clsx("h-full w-full object-contain object-center")}
					/>
				</div>
			) : (
				<DefaultImage />
			)}
		</div>
	);
};

Image.propTypes = {
	className: PropTypes.string,
	image: PropTypes.object.isRequired,
};

export default Image;
